export default "__VITE_ASSET__c3fa68ea__"